import { render, staticRenderFns } from "./sitestatic.vue?vue&type=template&id=15b172ae&scoped=true"
import script from "./sitestatic.vue?vue&type=script&lang=js"
export * from "./sitestatic.vue?vue&type=script&lang=js"
import style0 from "./sitestatic.vue?vue&type=style&index=0&id=15b172ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b172ae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/carousel/sitestatic.vue
// module id = null
// module chunks = 